// extracted by mini-css-extract-plugin
export default {"button":"Wallet_button__bz6cE","divider":"Wallet_divider__WDBam","link":"Wallet_link__3LmET"};